<template>
  <v-container class="pa-0 ma-0 academics-page">
    <h1 class="show-title mb-10">Useful Links</h1>

    <div class="mt-3 academics-text">
      <ul>
        <li>
          Instituto Nacional da Propriedade Intelectual (
          <b>INPI</b>):
          <a target="_blank" href="https://inpi.justica.gov.pt/"
            >https://inpi.justica.gov.pt/</a
          >
        </li>
        <li>
          Inspeção Geral das Atividades Culturais (
          <b>IGAC</b>):
          <a target="_blank" href="https://www.igac.gov.pt/"
            >https://www.igac.gov.pt/</a
          >
        </li>
        <li>
          European Patent Office (
          <b>EPO</b>):
          <a target="_blank" href="https://www.epo.org/"
            >https://www.epo.org/</a
          >
        </li>
        <li>
          World Intellectual Property Organization (
          <b>WIPO</b>):
          <a target="_blank" href="https://www.wipo.int/"
            >https://www.wipo.int/</a
          >
        </li>
      </ul>
    </div>

    <div class="mt-3 academics-text">
      <h2>Patent databases</h2>
      <ul>
        <li>
          Espacenet:
          <a target="_blank" href="https://worldwide.espacenet.com/"
            >https://worldwide.espacenet.com/</a
          >
        </li>
        <li>
          Patentscope:
          <a
            target="_blank"
            href="https://patentscope.wipo.int/search/en/search.jsf"
            >https://patentscope.wipo.int/search/en/search.jsf</a
          >
        </li>
        <li>
          Google Patents:
          <a target="_blank" href="https://patents.google.com/"
            >https://patents.google.com/</a
          >
        </li>
        <li>
          INPI:
          <a
            target="_blank"
            href="https://servicosonline.inpi.pt/pesquisas/main/patentes.jsp?lang=PT"
            >https://servicosonline.inpi.pt/pesquisas/main/patentes.jsp?lang=PT</a
          >
        </li>
      </ul>
    </div>

    <div class="mt-3 academics-text">
      <h2>Trademark search</h2>
      <ul>
        <li>
          TMView:
          <a target="_blank" href="https://www.tmdn.org/tmview"
            >https://www.tmdn.org/tmview</a
          >
        </li>
        <li>
          INPI:
          <a
            target="_blank"
            href="https://servicosonline.inpi.pt/pesquisas/main/marcas.jsp?lang=PT"
            >https://servicosonline.inpi.pt/pesquisas/main/marcas.jsp?lang=PT</a
          >
        </li>
      </ul>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'UsefulLinks',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style></style>
